import gql from 'graphql-tag';

export const getTeamsByNameQuery = gql`
  query GetTeamsByName($name: String!, $organisationId: String!) {
    getTeamsByName(name: $name, organisationId: $organisationId) {
      teamId
      name
      imageUrl
      membersCount
    }
  }
`;

const getTeamsByName = () => ({
  query: getTeamsByNameQuery,
  module: 'users',
  ignoreCache: true,
  buildVariables: ({ name, organisationId }) => ({
    name, organisationId
  })
});

export default getTeamsByName;